import Vue from 'vue'
import VueRouter from 'vue-router'
import vueConfig from '@/../vue.config'
Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'history',
    base: vueConfig.publicPath,
    routes: [
        {
            path: '/',
            name: 'Home Route',
            component: () => import('@/components/routes/HomeRoute'),
            meta: {
                title: 'Home Route'
            }
        },
        {
            path: '/code/:code',
            name: 'Referral Route',
            component: () => import('@/components/routes/ReferralRoute'),
            meta: {
                title: 'Referral Route'
            }
        },
        {
            path: '/404',
            name: '404Route',
            alias: '*',
            component: () => import('@/components/routes/HomeRoute')
        }
    ]
})

router.afterEach((to, from) => {
})

router.beforeEach((to, from, next) => {
    next()
})

export default router
